import React, { Component } from 'react';
import slugify from 'slugify';

import Icon from './Icon';

class Form extends Component {
  constructor(props) {
    super(props);

    this.topElementRef = React.createRef();
  }

  smoothScrollToElement(ref) {
    ref.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  componentDidMount() {
    if (this.props.smoothScrollToTop) {
      this.smoothScrollToElement(this.topElementRef);
    }
  }

  render() {
    return (
      <div className="u-absolute u-pin-l md:u-p-4 u-w-full u-mt-0" ref={this.props.innerRef}>
        <fieldset className="u-pb-4 border-bottom">
          <legend className="legend u-pb-0 u-font-bold" ref={this.topElementRef}>
            So we can give you the most appropriate guidance, please tell us whether you are:
          </legend>
          {/* <p className="u-mt-4 u-text-sm">
            So we can give you the most appropriate guidance, please tell us whether you are:
          </p> */}
          <div className="u-flex u-flex-wrap u-mt-0">
            <div className="u-flex-auto u-mt-4 u-mr-2">
              <input
                type="radio"
                name="gender"
                id="gender-female"
                value="Female"
                onChange={this.props.handleUserUpdate}
                checked={this.props.user.gender === 'Female'}
              />
              <label htmlFor="gender-female" className="inline-label">
                Female
              </label>
            </div>
            <div className="u-flex-auto u-mt-4 u-mr-2">
              <input
                type="radio"
                name="gender"
                id="gender-male"
                value="Male"
                onChange={this.props.handleUserUpdate}
                checked={this.props.user.gender === 'Male'}
              />
              <label htmlFor="gender-male" className="inline-label">
                Male
              </label>
            </div>
            <div className="u-flex-auto u-mt-4 u-mr-2">
              <input
                type="radio"
                name="gender"
                id="gender-self-describe"
                value="Self describe"
                onChange={this.props.handleUserUpdate}
                checked={this.props.user.gender === 'Self describe'}
              />
              <label htmlFor="gender-self-describe" className="inline-label">
                Self describe
              </label>
            </div>
            <div className="u-flex-auto u-mt-4 u-mr-2">
              <input
                type="radio"
                name="gender"
                id="gender-prefer-not-to-say"
                value="Prefer not to say"
                onChange={this.props.handleUserUpdate}
                checked={this.props.user.gender === 'Prefer not to say'}
              />
              <label htmlFor="gender-prefer-not-to-say" className="inline-label">
                Prefer not to say
              </label>
            </div>
            <div className="u-w-full u-mt-0">
              {this.props.user.gender === 'Self describe' && (
                <input
                  type="text"
                  name="genderCustom"
                  id="gender-custom"
                  value={this.props.user.genderCustom}
                  onChange={this.props.handleUserUpdate}
                  placeholder="Descibe your gender here"
                  className="u-appearance-none u-border rounded u-w-full u-mt-4 u-py-2 u-px-3 u-leading-tight u-focus:outline-none u-focus:shadow-outline"
                />
              )}
            </div>
          </div>
          <p className="u-mt-4 u-text-sm">
            We ask for this information because the{' '}
            <a
              href="https://www.gov.uk/government/publications/alcohol-consumption-advice-on-low-risk-drinking"
              target="_blank"
              rel="noopener noreferrer"
            >
              Chief Medical Officers'
            </a>{' '}
            guidance about hazardous and harmful levels of drinking is different for men and women.
          </p>
        </fieldset>
        <fieldset className="u-mt-4">
          <legend className="legend u-pb-0 u-pr-2 u-font-bold u-text-right">Drinks per week</legend>
          {this.props.drinks.map((drink, index) => (
            <div
              key={drink.name}
              className="u-flex u-justify-between u-mt-0 u-pt-4 u-pb-4 border-bottom"
            >
              <div className="u-flex-grow u-flex">
                <Icon name={drink.icon} className="u-h-8 u-w-8 u-mt-1 u-mr-3 u-text-purple" />
                <label
                  htmlFor={'drink-' + slugify(drink.name, { lower: true })}
                  className="u-pr-2 u-pb-0 u-leading-tight"
                >
                  <p className="u-text-sm">
                    {drink.name} ({drink.abv}%)
                  </p>
                  <p className="u-text-sm u-mt-0">{drink.volume}ml</p>
                </label>
              </div>
              <div className="u-mt-0">
                <div className="u-flex">
                  <button
                    onClick={() => this.props.decrementAnswer(drink.name)}
                    disabled={
                      !Number.isInteger(this.props.answers[drink.name]) ||
                      this.props.answers[drink.name] === this.props.minAnswer
                    }
                    className="u-bg-transparent u-border-none u-w-8"
                    aria-label={'Decrease ' + drink.name + ' per week by 1'}
                  >
                    <Icon name="arrow-left" className="u-text-orange" />
                  </button>
                  <input
                    type="text"
                    name={drink.name}
                    id={'drink-' + slugify(drink.name, { lower: true })}
                    value={this.props.answers[drink.name]}
                    onChange={this.props.updateAnswer}
                    className="u-w-16"
                  />
                  <button
                    onClick={() => this.props.incrementAnswer(drink.name)}
                    disabled={this.props.answers[drink.name] === this.props.maxAnswer}
                    className="u-bg-transparent u-border-none u-w-8"
                    aria-label={'Increase ' + drink.name + ' per week by 1'}
                  >
                    <Icon name="arrow-right" className="u-text-orange" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </fieldset>
        <div className="u-text-right u-mt-6">
          <button type="button" onClick={() => this.props.goTo('result')} className="button">
            See results
          </button>
        </div>
      </div>
    );
  }
}

export default Form;
